"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpModalHost = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const modal_plugin_1 = require("./modal-plugin");
let ItpModalHost = class ItpModalHost extends vue_1.default {
    hostName;
    errorCaptured(err, vm, info) {
        (0, modal_plugin_1.getModalManager)(this).errorCaptured(err, vm, info);
    }
};
exports.ItpModalHost = ItpModalHost;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'imodal' }),
    __metadata("design:type", String)
], ItpModalHost.prototype, "hostName", void 0);
exports.ItpModalHost = ItpModalHost = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: '<portal-target :name=hostName multiple></portal-target>'
    })
], ItpModalHost);
//# sourceMappingURL=modal-host.js.map